module.exports = __webpack_public_path__ + "static/media/9_2.984281c2.png";